import { useState } from "react";
import {
  RequestDeleteBaseRequestWrapper,
  BasesDeleteBasePostRequest,
  BasesApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiDeleteBase = () => {
  const [deleteBaseResult, setDeleteBaseResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteBases = async (req: RequestDeleteBaseRequestWrapper) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: BasesDeleteBasePostRequest = {
        wrapperReq: req,
      };
      const api = new BasesApi(config);
      const response = await api.basesDeleteBasePost(request);
      setDeleteBaseResult(response);
      return response;
    } catch (err) {
      setError("拠点削除に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { deleteBases, error, isLoading };
};
